import './header.scss'

const Header = function () {
  return <h1 className='nav'>error</h1>
}

export default Header
